import React, { useMemo } from 'react';
import { ApolloError } from '@apollo/client';

import { Feature, useEnabledFeaturesQuery } from '../generated/graphql';

interface FeatureFlagContextType {
  enabledFeatures: string[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  isFeatureEnabled: (feature: Feature) => boolean;
}

const FeatureFlagContext = React.createContext<FeatureFlagContextType>(null!);

export const FeatureFlagProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const {
    data: enabledFeaturesQueryData,
    loading,
    error,
  } = useEnabledFeaturesQuery();
  const enabledFeatures = enabledFeaturesQueryData?.enabledFeatures;

  const featureSet = useMemo(() => new Set(enabledFeatures), [enabledFeatures]);

  const isFeatureEnabled = (feature: Feature) => {
    return featureSet.has(feature);
  };

  return (
    <FeatureFlagContext.Provider
      value={{
        enabledFeatures,
        loading,
        error,
        isFeatureEnabled,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => {
  return React.useContext(FeatureFlagContext);
};
